import { useRouter } from "next/navigation";

import { Button } from "@/components/atoms";
import Vouchers from "@/lib/checkout/Vouchers";
import useLocation from "@/lib/hooks/useLocation";
import type { CartHook } from "@/lib/hooks/useSelection/cart/useCart";
import useCart from "@/lib/hooks/useSelection/cart/useCart";
import {
  convertCartToGTagItem,
  eventBeginCheckout,
} from "@/lib/utils/Analytics/Functions";

import { CartItemMaybeHooked } from "@/lib/hooks/useSelection/cart/useItems";
import styles from "./cart-summary.module.css";
const CartSummary = ({
  summary,
  modal,
  onlyData = false,
  items,
}: {
  summary: CartHook["cart"]["summary"] | undefined;
  modal?: CartHook["modal"];
  onlyData?: boolean;
  items?: CartItemMaybeHooked[] | null;
}) => {
  const router = useRouter();
  const { currency } = useLocation();
  const { cart } = useCart();
  const goToCheckout = () => {
    if (modal) modal?.toggleModal();
    router.push("/checkout");
    eventBeginCheckout({
      currency: currency || "",
      value: cart.summary?.prices.totalAsNumber,
      items: cart.items.map((item) => convertCartToGTagItem(item)),
    });
  };

  const closeModal = () => {
    if (modal) modal?.toggleModal();
  };

  const emptyCart = !cart.summary?.totalQuantity;

  let hasGiftbox = 0;
  items?.forEach((item) => {
    if (item?.giftbox) {
      hasGiftbox++;
    }
  });

  return (
    <div className={styles.summary}>
      {!modal && !onlyData && <Vouchers />}
      <div className={styles.subtotals}>
        <span>
          <p>SUBTOTAL</p>
          <p>{summary?.prices?.total ?? "0,-"}</p>
        </span>
        {!!summary?.discount?.[0]?.priceOff && (
          <span>
            <p>DISCOUNT</p>
            <p>{summary?.discount?.[0]?.priceOff ?? "0,-"}</p>
          </span>
        )}

        {!!hasGiftbox && (
          <span>
            <p>GIFTBOX x {hasGiftbox}</p>
            <p>{"0 NOK"}</p>
          </span>
        )}

        <span>
          <p>SHIPPING</p>
          <p>
            {summary?.prices?.shippingAsNumber === 0
              ? "Free"
              : summary?.prices?.shipping}
          </p>
        </span>
      </div>

      <span className={styles.grandtotal}>
        <p>TOTAL</p>
        <p>{summary?.prices?.grandTotal ?? "0,-"}</p>
      </span>
      {modal && (
        <div className={styles.cart__actions}>
          <Button color="transparent" outlined grow onClick={closeModal}>
            <span className="uppercase">Continue shopping</span>
          </Button>
          <Button
            color="black"
            textColor="white"
            grow
            shadow
            disabled={emptyCart}
            onClick={goToCheckout}
          >
            <span className="uppercase">Checkout</span>
          </Button>
        </div>
      )}
    </div>
  );
};

export default CartSummary;
